import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Header from '../../common/Header/Header';
import GenericButton from '../../common/button/GenericButton/GenericButton';
import ToastMessage from '../../common/ToastMessage/index';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';
import './EditAffiliationRequest.scss';
import FacilityFilterPanel from '../../User/Personas/Providers/Facility';
import DoctorFilterPanel from '../../User/Personas/Providers/Doctors';
import { BackAvatarSVG } from '../../../img/GlobalSVG';

const EditAffiliationRequest = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const stateData = location.state && location.state;
  const [formData, setFormData] = useState(stateData.affliationData);
  //const [isContinueClicked, setIsContinueClicked] = useState(false);
  const [loader, setLoader] = useState(false);
  console.log('stateData', stateData);

  const handleOnCancel = () => {
    navigate(`/admin/approval-requests?trx=${stateData?.recordIndex?.Oid}`, {
      state: {
        recordIndex: location.state.recordIndex,
        previousState: location.state.previousState,
      },
    });
    //navigate({ pathname: '/admin/configure-links' });
  };
  const selectDoctors = {};
  if (stateData.doctorFacilityFlag === 'facility') {
    stateData?.preSelectedData &&
      stateData?.preSelectedData?.map((item) => {
        if (item?.PhysicianOid && item?.PhysicianOid.length > 0) {
          const foid = item?.FacilityDetails[0]?.FacilityOID;
          selectDoctors[foid] = item?.FacilityDetails[0]?.PhysicianDetails;
        }
      });
  }

  const formFields = {
    Oid: '',
    userType: { value: '' },
    brokers: [],
    allBrokers: [],
    BLOBDetails: {
      blobSelected: [],
      allBLOBData: [],
      selectedEmployers: {},
      allEmployersData: [],
      selectedLocations: {},
      allLocationsData: [],
    },
    providerDetails: {
      facilities:
        stateData.doctorFacilityFlag === 'facility'
          ? stateData?.preSelectedData?.map(
              (item) => item?.FacilityDetails[0],
            ) || []
          : [],
      selectedDoctorsByFacility:
        stateData.doctorFacilityFlag === 'facility'
          ? selectDoctors
            ? selectDoctors
            : {}
          : {},
    },
    personalInformation: {},
    permissions: [],
    allPermissions: [],
    doctors:
      stateData.doctorFacilityFlag === 'doctor'
        ? stateData?.preSelectedData
          ? stateData?.preSelectedData
          : []
        : [],
  };

  const [selectedDoctorsData, setSelectedDoctorsData] = useState(
    stateData.doctorFacilityFlag === 'doctor'
      ? stateData?.preSelectedData
        ? stateData?.preSelectedData
        : []
      : [],
  );
  const [selectedFacilityData, setSelectedFacilityData] = useState(
    stateData.doctorFacilityFlag === 'facility'
      ? stateData?.preSelectedData?.map((item) => item?.FacilityDetails[0]) ||
          []
      : [],
  );
  const [selectedFacilityDoctors, setSelectedFacilityDoctors] = useState(
    selectDoctors || [],
  );

  const onSelectedDostorsCount = (length) => {
    //setHasDoctors(length > 0);
  };

  const onSelectedFacilitiesCount = (length) => {
    //setHasFacilities(length > 0);
  };

  const onSelectedFacilities = (brokers) => {
    onSelectedFacilitiesLists(brokers);
    setSelectedFacilityData(brokers);
    console.log(
      'need to add function in props',
      brokers,
      selectedFacilityDoctors,
    );
  };

  const onSelectedFacilitiesLists = (value) => {
    console.warn('need to add function in props');
  };

  const handleValChange = (event) => {
    console.log('event', event);
  };

  const nextStep = () => {
    console.log('nextStep values');
  };

  const onSetAllFacilities = (value) => {
    console.log('facility faran', value);
    setSelectedFacilityData(value);
    //if (value?.length > 0) {
    //setHasFacilities(true);
    //} else {
    //setHasFacilities(false);
    //}
  };

  const onSelectedDoctorsList = (value) => {
    console.log('value', value);
    setSelectedDoctorsData(value);
    //if (value?.length > 0) {
    //setHasDoctors(true);
    //} else {
    //setHasDoctors(false);
    //}
  };

  const deleteSelectedDoctorId = (doctorId) => {
    console.log('createUserFormData before delete >>>', doctorId);
    setSelectedDoctorsData(
      [...selectedDoctorsData].filter((doc) => doc.ConnectorID !== doctorId),
    );
    //if (
    //[...selectedDoctorsData].filter((doc) => doc.ConnectorID !== doctorId)
    //?.length > 0
    //) {
    //setHasDoctors(true);
    //} else {
    //setHasDoctors(false);
    //}
  };

  const getSelectedDoctor = (event) => {
    console.log(event, 'event doctors');
    setSelectedFacilityDoctors(event.target.value.selectedDoctorsByFacility);
  };
  const updateUserAffiliation = async () => {
    setLoader(true);
    let affliationData = [];
    console.log(
      selectedFacilityDoctors,
      selectedFacilityData,
      'selectedFacilityDoctors',
    );
    stateData.doctorFacilityFlag === 'doctor'
      ? (affliationData = selectedDoctorsData)
      : (affliationData = selectedFacilityData);
    const affliations = [];
    affliationData &&
      affliationData.map((data) => {
        const Physician = [];
        if (stateData.doctorFacilityFlag === 'doctor') {
          Physician.push({
            PhysicianOid: data?.PhysicainOid,
            ConnectorId: data?.ConnectorID,
          });
          affliations.push({
            FacilityOid: data.FacilityOid,
            PhysicianData: Physician && Physician,
          });
        } else {
          for (const key in selectedFacilityDoctors) {
            if (key === data?.FacilityOID) {
              selectedFacilityDoctors[key] &&
                selectedFacilityDoctors[key].map((item) => {
                  Physician.push({
                    PhysicianOid: item?.PhysicainOid,
                    ConnectorId: item?.ConnectorID,
                  });
                });
            }
          }
          affliations.push({
            FacilityOid: data.FacilityOID,
            PhysicianData: Physician && Physician,
          });
        }
      });
    const apiPayload = {
      UpdateUser: {
        Oid: formData.Oid,
        FirstName: formData?.FirstName,
        MiddleName:
          formData?.MiddleName !== undefined ? formData?.MiddleName : '',
        LastName: formData?.LastName,
        Status: 'Pending',
        UserType: 'Provider',
        SuperUser: false,
        UserID: formData?.UserID,
        UserProviderAffiliationDetails: affliations,
        IsDoctorFacility:
          stateData.doctorFacilityFlag === 'doctor' ? true : false,
      },
    };

    try {
      const response = await axiosInstance.put(
        APIEndpoints.updateUserProviderSelfRegistration(),
        apiPayload,
      );
      //updateProviderSelfRegistration
      if (
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
      ) {
        toast.success(
          <ToastMessage
            type="success"
            subTitle={'Provider Affiliation has been updated successfully!.'}
          />,
        );
        //props.updateCallback();
        //props.updateSelectedMemberEmailID(props.userIndex, emailVal);
        //handleClose();
        handleOnCancel();
      }
    } catch (error) {
      console.log(error);

      toast.error(
        <ToastMessage
          type="error"
          subTitle={
            'Something went wrong! Provider Affiliation could not be updated. Try again later.'
          }
        />,
      );
    } finally {
      setLoader(false);
    }
  };
  return (
    <div className="approval-edit-request-container">
      <div className="d-flex align-items-center border-bottom">
        <div className="back-arrow col cursor-pointer">
          <div aria-label="back button" onClick={handleOnCancel} to="#">
            <BackAvatarSVG.BackArrowSVG />
          </div>
        </div>
        <div className="col">
          <h1 id="greetings-time" className=" p-0 pb-2">
            Edit User Profile
          </h1>
        </div>
      </div>

      <div className="mt-3 edit-affilitaion-request-container">
        <div className="edit-section">
          <div className="headers-section">
            <div>Provider</div>
            <div className="sub-heading">
              Affiliate at least one doctor or facility to proceed.
            </div>
          </div>
          <hr className="divider" />
          <div className="mt-2 affliation-container">
            {stateData?.doctorFacilityFlag === 'facility' && (
              <div className="add-button-container border-separator-top">
                <FacilityFilterPanel
                  label={' Add Facility'}
                  updateSelectedItemCount={onSelectedFacilitiesCount}
                  handleValChange={handleValChange}
                  //isContinueClicked={isContinueClicked}
                  nextStep={nextStep}
                  onSelectedItems={onSelectedFacilities}
                  createUserFormData={formFields}
                  onSelectAllItems={onSetAllFacilities}
                  selectedItemsData={selectedFacilityData}
                  selectedFacilityDoctors={selectedFacilityDoctors}
                  setSelectedItemsData={setSelectedFacilityData}
                  getSelectedDoctor={getSelectedDoctor}
                  editAffiliatedRecords={true}
                  allowDoctorSelection={true}
                />
              </div>
            )}
            {stateData?.doctorFacilityFlag === 'doctor' && (
              <div className="add-button-container border-separator-bottom">
                {selectedDoctorsData && (
                  <DoctorFilterPanel
                    label={' Add Doctor'}
                    updateSelectedItemCount={onSelectedDostorsCount}
                    isContinueClicked={false}
                    nextStep={nextStep}
                    selectedItemsData={selectedDoctorsData}
                    setSelectedItemsData={onSelectedDoctorsList}
                    editAffiliatedRecords={true}
                    onDeleteSelectedDoctor={(docId) => {
                      deleteSelectedDoctorId(docId);
                    }}
                    handleValChange={handleValChange}
                  />
                )}
              </div>
            )}
            <div className="bottom-controls-container">
              <Row>
                <Col className="d-flex justify-content-end">
                  <GenericButton
                    className="cancel-edit-affiliation-button"
                    variant="link"
                    onClick={handleOnCancel}
                  >
                    {t('label_cancel')}
                  </GenericButton>

                  <GenericButton
                    className="submit-edit-affiliation-button"
                    onClick={() => {
                      updateUserAffiliation();
                    }}
                  >
                    {t('label_save')}
                  </GenericButton>
                </Col>
              </Row>
            </div>
          </div>
        </div>
        <div className="right-side-content"></div>
      </div>
    </div>
  );
};
export default EditAffiliationRequest;
